// extracted by mini-css-extract-plugin
export default {"cardContainer":"InfiniteScroll_cardContainer__ZKQ6H","card":"InfiniteScroll_card__Y2-BE","placeholder":"InfiniteScroll_placeholder__7+nZp"};